import { CaretLeftIcon } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import * as compSettings from "./settings";
const PageHeader = ({
  id,
  extendedSettings,
  title,
  onBackClick: CustomBack,
  safeArea,
}) => {
  const navigate = useNavigate();

  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };

  // Settings'ten değerleri al
  const backgroundColor = settings.backgroundColor.value;
  const borderBottomColor = settings.borderBottomColor.value;
  const titleColor = settings.titleColor.value;
  const iconColor = settings.iconColor.value;
  const buttonBackgroundColor = settings.buttonBackgroundColor.value;
  const buttonHoverBackgroundColor = settings.buttonHoverBackgroundColor.value;
  const paddingX = settings.paddingX.value + "px";
  const paddingY = settings.paddingY.value + "px";
  const safeAreaPadding = settings.safeAreaPadding.value;
  const gapBetweenItems = settings.gapBetweenItems.value + "px";
  const titleMarginLeft = settings.titleMarginLeft.value + "px";
  const borderBottomWidth = settings.borderBottomWidth.value + "px";
  const buttonSize = settings.buttonSize.value + "px";
  const buttonBorderRadius = settings.buttonBorderRadius.value + "px";
  const iconSize = settings.iconSize.value;
  const titleFontSize = settings.titleFontSize.value + "px";
  const titleFontWeight = settings.titleFontWeight.value;
  const titleLineHeight = settings.titleLineHeight.value;
  const animationDuration = settings.animationDuration.value + "ms";
  const showBorder = settings.showBorder.value;
  const showBackButton = settings.showBackButton.value;
  const hoverEffects = settings.hoverEffects.value;
  const centerTitle = settings.centerTitle.value;
  const stickyHeader = settings.stickyHeader.value;
  const iconWeight = settings.iconWeight.value;
  const shadowColor = settings.shadowColor.value;
  const showShadow = settings.showShadow.value;
  const shadowBlur = settings.shadowBlur.value + "px";
  const titleMaxWidth = settings.titleMaxWidth.value;
  const titleTruncate = settings.titleTruncate.value;

  const onBackClick = () => {
    if (CustomBack) {
      CustomBack();
      return;
    } else {
      if (window.history.length > 2) {
        navigate(-1);
      } else {
        navigate("/");
      }
    }
  };

  const getBoxShadow = () => {
    if (!showShadow) return "none";
    return `0 2px ${shadowBlur} ${shadowColor}`;
  };

  const getTitleStyle = () => {
    const baseStyle = {
      fontSize: titleFontSize,
      fontWeight: titleFontWeight,
      color: titleColor,
      lineHeight: titleLineHeight,
      marginLeft: titleMarginLeft,
    };

    if (titleMaxWidth > 0) {
      baseStyle.maxWidth = titleMaxWidth + "px";
    }

    if (titleTruncate) {
      baseStyle.overflow = "hidden";
      baseStyle.textOverflow = "ellipsis";
      baseStyle.whiteSpace = "nowrap";
    }

    return baseStyle;
  };

  return (
    <div
      style={{
        paddingTop: (safeArea?.top || 0) + safeAreaPadding + "px",
        paddingLeft: paddingX,
        paddingRight: paddingX,
        paddingBottom: paddingY,
        backgroundColor: backgroundColor,
        borderBottom: showBorder
          ? `${borderBottomWidth} solid ${borderBottomColor}`
          : "none",
        boxShadow: getBoxShadow(),
        position: stickyHeader ? "sticky" : "static",
        top: stickyHeader ? "0" : "auto",
        zIndex: stickyHeader ? "10" : "auto",
        display: "flex",
        alignItems: "center",
        gap: gapBetweenItems,
        justifyContent: centerTitle ? "center" : "flex-start",
      }}
    >
      {showBackButton && (
        <button
          onClick={onBackClick}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: buttonSize,
            height: buttonSize,
            borderRadius: buttonBorderRadius,
            backgroundColor: buttonBackgroundColor,
            border: "none",
            transition: hoverEffects ? `all ${animationDuration} ease` : "none",
            position: centerTitle ? "absolute" : "static",
            left: centerTitle ? paddingX : "auto",
          }}
          onMouseEnter={(e) => {
            if (hoverEffects) {
              e.target.style.backgroundColor = buttonHoverBackgroundColor;
            }
          }}
          onMouseLeave={(e) => {
            if (hoverEffects) {
              e.target.style.backgroundColor = buttonBackgroundColor;
            }
          }}
          aria-label="Geri"
        >
          <CaretLeftIcon
            weight={iconWeight}
            width={iconSize}
            height={iconSize}
            style={{ color: iconColor }}
          />
        </button>
      )}
      <h1 style={getTitleStyle()}>{title}</h1>
    </div>
  );
};

export default PageHeader;
